import RequestAbstract from "../abstract";

/**
 * Empty string is not "unset" to the payment core: `currency: ""` would override
 * the terminal's own currency with nothing, and a blank optional field is worse
 * than an absent one on every other key too. The dialog seeds every field in its
 * Head to '', so without this almost every request would carry a dozen of them.
 */
const withoutBlanks = (body) =>
    Object.fromEntries(
        Object.entries(body).filter(
            ([, value]) => value !== '' && value !== null && value !== undefined
        )
    );

export default class PublicMerchantTerminals extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-merchant-terminals";
    }

    /**
     * Create a payment for this terminal. The cabinet signs the call to the
     * payment core with the terminal's own credentials; from here it is an
     * ordinary authenticated POST.
     */
    async createPayin(id, body) {
        return await this.post(`${this.link}/${id}/payin`, withoutBlanks(body));
    }

    /** Create a payout for this terminal. See createPayin. */
    async createPayout(id, body) {
        return await this.post(`${this.link}/${id}/payout`, withoutBlanks(body));
    }
}
